module.exports = __webpack_public_path__ + "static/img/2.b078695.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/publish/2.png
// module id = stvY
// module chunks = 1